module.exports = __webpack_public_path__ + "static/media/invoice_with_labor.17423c8f.png";